/**
 * Created by jyy on 18/7/6.
 */

const state = {
    styleArr: [],
    customStyles: [],
    customClassStyles: [],
};

const mutations = {
    SET_FLAG_INFO(state, flagInfo) {
        state.flagInfo = flagInfo;
    },
    INIT_STYLE_ARR(state, styleArr) {
        state.styleArr = styleArr;
    },
    INIT_SYSTEM_CLASS_STYLES_CACHE(state, systemClassStyles) {
        state.systemClassStylesCache = systemClassStyles;
    },
    INIT_CUSTOM_CLASS_STYLES(state, customClassStyles) {
        state.customClassStyles = customClassStyles;
    },
    ADD_ONE_STYLE(state, style) {
        state.styleArr.push(style);
    },
    UPDATE_STYLE(state, style) {
        // console.log('style:', style);
        style.forEach((item) => {
            var temp = state.styleArr.find((val) => {
                return item.groupId === val.groupId && item.selectorId === val.selectorId;
            });
            Object.assign(item, temp);
        })
    },
    INIT_CUSTOM_STYLES(state, styles) {
        state.customStyles = styles;
    },
    REFRESH_SYSTEM_CLASS_STYLES(state, systemClassStylesCache) {
        state.styleArr = JSON.parse(JSON.stringify(systemClassStylesCache));
    },
    UPDATE_CUSTOM_CLASS_STYLES(state, className, control) {
        const index = state.customClassStyles.findIndex(style => style.props.classStyle[0].className === className);
        if (index === -1) {
            state.customClassStyles.push(control);
        } else {
            state.customClassStyles[index] = control;
        }
    },
    ADD_CUSTOM_CLASS_STYLES(state, controls) {
        state.customClassStyles = controls;
    }
};

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/classStyle.js